/*! Goldtop - the shared option sheet. Every width.
    Styled by assets/gt-slidecart-size.css. Loaded from theme.liquid, because
    the slide cart it serves is on every page.

    ==================================================================
    WHY THIS FILE EXISTS.

    Three surfaces on this site ask a shopper to pick a variant in a sheet that
    slides up from the bottom:

      1. the slide cart's "Change size or colour?" on a cart line
      2. the "Pairs well with" ADD button on a product page
      3. the slide cart's "You might also like" upsells

    Until 28 Sep each of those owned its own sheet. That is how four separate
    freezes came to be fixed in (1) and reach neither of the others: a stale
    open re-opening a closed sheet, a scrim still hit-testing after close, a
    slide-up that never ran because requestAnimationFrame does not fire in a
    hidden tab, and a confirm button sitting underneath the bottom chrome. Each
    was found the hard way, twice.

    So the sheet is one thing now, and the surfaces are thin callers that say
    what to show and what to do on confirm. A fix lands once.

    ==================================================================
    THE FOUR FIXES, KEPT HERE SO THEY CANNOT BE LOST AGAIN.

    1. THE SLIDE-UP NEEDS A TIMER AS WELL AS FRAMES. The class that runs the
       animation has to land in a later frame than the one that unhides the
       panel, or there is no starting transform to animate from. A double
       requestAnimationFrame buys that and has one failure mode: rAF does not
       run at all while a tab is hidden or while a page is restored from the
       back-forward cache, so the panel stays at translateY(100%) - off the
       bottom of the screen - while the scrim covers the viewport. A dead page
       with nothing visible on it is what a shopper calls a freeze. A 60ms
       setTimeout races the frames; both add the same class and adding it twice
       costs nothing.

    2. AN ELEMENT AT OPACITY 0 IS STILL THERE. Probed at 120ms after close, the
       scrim was still what elementFromPoint returned in the middle of the page.
       The stylesheet answers it in one rule - pointer-events: none unless
       .is-open - and the hide is deferred only so the panel can slide out.

    3. EVERY OPEN AND EVERY CLOSE TAKES A TICKET. Without it a frame the phone
       delayed lands after the shopper has closed the sheet and puts the class
       back, leaving a transparent full-screen layer with no state behind it.
       A callback that finds its ticket spent does nothing. healSheet() is the
       belt to that pair of braces.

    4. THE CONFIRM BUTTON CAN BE UNDERNEATH THE BOTTOM CHROME. Measured on the
       preview: the button on screen, enabled, correctly labelled, and
       elementFromPoint over it returning IFRAME#PBarNextFrame with
       DIV#PBarNextFrameWrapper as the blocker. clearBottomChrome asks the
       document what is actually under the button and pads the panel until the
       answer is the button. THREE PASSES, not one, because chrome that mounts
       after the sheet is invisible to a single measurement - a cookie banner,
       a chat launcher, a sticky buy bar, or the preview bar itself.

    The method lesson behind all four, worth more than any of them: for
    anything with a fixed overlay, elementFromPoint is the acceptance test.
    Class lists and cart contents were correct every single time the page was
    unusable.

    ==================================================================
    WHAT THE SHEET SHOWS, AND WHY IT MIRRORS THE PDP.

      is-on      the current selection
      is-gone    no buyable variant here, marked BEFORE the tap
      the note   which of the two unbuyable cases it is, in a sentence, and
                 the PDP's traffic light the rest of the time

    NOTHING IS DISABLED except the confirm button, which tells the truth rather
    than pretending it will work. A control that refuses a tap and says nothing
    is the worst of both.

    THE STATUS LINE CARRIES NO FULL STOP. Joe, 28 Sep: the sold-out line should
    read "Black is currently sold out" rather than "Black is sold out.", to
    match the traffic light beside it - "In stock, ready to ship" has never had
    one. "Currently" is the substantive half of that change: sold out is a
    state, not a verdict on the product, and a shopper who reads it as
    temporary is a shopper who comes back. The two-sentence failure messages
    further down keep their stops, because dropping the last one from a pair of
    sentences reads as a typo rather than as a style.

    A SIZE RAIL ANSWERS A DIFFERENT QUESTION FROM THE REST. A size is marked
    gone only when NO variant of the product has it - it is out of the
    catalogue, not merely wrong against the colour in front of you. Every other
    rail is judged against the current selection. Without the asymmetry,
    changing colour makes sizes appear and disappear under the shopper's finger.
    This is the PDP's own rule and shoppers have already learned it.

    ==================================================================
    WHERE IT LIVES IN THE DOM, WHICH IS NOT A DETAIL.

    The sheet is appended to <body>, deliberately and immovably.

    SlideCart HQ ships `.slidecarthq, .slidecarthq *` - a 140-declaration reset
    on every descendant of its drawer, at specificity (0,1,0), loading after the
    theme. It resets background, border, box-shadow, colour, display, font-size,
    letter-spacing, line-height, padding, margin, position, text-transform,
    transform, width, height and z-index. Building these controls inside the
    drawer was tried and measured on 28 Sep: chips came out 122x23 with no
    border at 16px type, and swatches collapsed to 0x0. Every one of our
    declarations ties on specificity and loses on order.

    So a caller inside the drawer opens THIS sheet rather than injecting
    controls into the app's panel. Outside the drawer the reset cannot reach,
    and one stylesheet dresses all three surfaces.

    ==================================================================
    NO PRICE IS FORMATTED HERE. THE UPCHARGES ARE, AND THEY COME FROM LIQUID.

    Every price on this site is rendered by Liquid's money filter. Formatting
    one in JavaScript means reimplementing the shop's currency format, and it
    will be wrong for somebody. The surface that opened the sheet already shows
    the price; the sheet is for choosing.

    Joe, 28 Sep: the jacket's 50 and 52 chips should carry the "+50" the PDP
    shows, "and also for other items which have variable prices for the
    different options". So the sheet now prints an upcharge - and it prints it,
    nothing more. templates/product.gt-stock.liquid computes every option
    value's difference from the product's cheapest variant and renders it
    through money_without_trailing_zeros; the string arrives finished. Nothing
    below parses it, adds to it, or reformats it.

    A CHIP CARRIES ITS OWN UPCHARGE. A SWATCH CANNOT. A colour rail is a row of
    26px circles with nowhere to put text, and the PDP has no answer for this
    either - it only ever emitted deltas for the size rail. Two products in
    these sheets are priced by colour (the Leather Tank Bag, the Predator), so
    a swatch rail's upcharge goes on the summary line under the title, beside
    the colour's name, which is the one place the sheet already spells a colour
    out in words.

    ==================================================================
    THE API.

      GTSheet.open({
        product:      required, the object from /products/<handle>.js
        startId:      variant id to open on; falls back to the first buyable
        confirmLabel: the button's word when it can be pressed. "ADD TO CART"
        busyLabel:    while it is working. "ADDING..."
        failed:       a message to open with, for a retry after a failure
        afterAdd:     "open" opens the slide cart, "refresh" only updates it -
                      use "refresh" when the drawer is already on screen
        onConfirm:    optional. fn(variant, done, fail). The caller does the
                      work and calls one of them. Omitted, the sheet adds the
                      variant to the cart itself.
      })

      GTSheet.close()
      GTSheet.isOpen()

    GTSheet.open is a no-op when the product has no variants.

    NO WIDTH GATE, SINCE 28 SEP. The sheet used to refuse to open above 768px,
    because all three callers were mobile only. Joe rolled the slide cart's two
    surfaces out to desktop, so the decision belongs to the caller rather than
    here: gt-slidecart-size.js and gt-slidecart-upsell.js open at every width,
    and gt-rec-add.js keeps its own breakpoint, so the "Pairs well with" cards
    on a product page are unchanged on desktop.
*/
(function () {
  if (window.GTSheet) return;

  var COLOUR = /colou?r/i;
  var SIZE = /size/i;

  /* A middle dot, written as a character code rather than as an escape. The
     theme upload endpoint decodes backslash-u escapes on the way through, so
     the literal escape arrives as a single non-ASCII byte in a file that has
     to stay ASCII. It cost one corrupted upload to find that out. */
  var SEP = "  " + String.fromCharCode(183) + "  ";

  var CONFIRM_TIMEOUT = 12000;

  var sheet = null, state = null, busy = false;
  var gen = 0;                 /* fix 3: every open and close takes a ticket */
  var stock = {}, swatchSrc = {};

  function q(s, r) { try { return (r || document).querySelector(s); } catch (e) { return null; } }
  function qa(s, r) { try { return [].slice.call((r || document).querySelectorAll(s)); } catch (e) { return []; } }

  /* ---------------------------------------------------------------- */
  /* Reading the catalogue.                                            */

  function optionNames(p) {
    return (p.options || []).map(function (o) {
      return String((o && o.name != null) ? o.name : o || "");
    });
  }

  function variantByValues(p, vals) {
    var i, j, v, ok;
    for (i = 0; i < p.variants.length; i++) {
      v = p.variants[i]; ok = true;
      for (j = 0; j < vals.length; j++) if (v.options[j] !== vals[j]) { ok = false; break; }
      if (ok) return v;
    }
    return null;
  }

  /* One row per option, in the catalogue's order, each carrying whether ANY
     buyable variant has each value. That flag is what separates a value gone
     for good from one merely wrong against the current selection. Built once
     per open, because it does not depend on what is selected. */
  function valueIndex(p) {
    var rows = [];
    p.variants.forEach(function (v) {
      (v.options || []).forEach(function (val, i) {
        if (val == null || val === "") return;
        if (!rows[i]) rows[i] = { order: [], alive: {}, photo: {} };
        var r = rows[i];
        if (r.alive[val] === undefined) { r.order.push(val); r.alive[val] = false; }
        if (v.available) r.alive[val] = true;
        if (!r.photo[val] && v.featured_image && v.featured_image.src) r.photo[val] = v.featured_image.src;
      });
    });
    return rows;
  }

  function sized(url, w) {
    if (!url) return "";
    if (/[?&]width=/.test(url)) return url;
    return url + (url.indexOf("?") > -1 ? "&" : "?") + "width=" + w;
  }

  function handleize(s) {
    return String(s).toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
  }

  /* ---------------------------------------------------------------- */
  /* The traffic light. Its own endpoint because /products/<handle>.js
     carries availability but not inventory_quantity, and "only 2 left"
     cannot be derived from a boolean.                                 */

  /* The upcharges. They arrive from the same endpoint as the stock, as a flat
     list of [option index, value, delta] triples, and are turned into a lookup
     once on arrival. EVERY DELTA IS ALREADY A MONEY STRING, rendered by
     Liquid - see templates/product.gt-stock.liquid. Nothing here parses one. */
  function deltaMap(j) {
    var m = [], rows = (j && j.d) || [], i, r, k;
    for (i = 0; i < rows.length; i++) {
      r = rows[i];
      if (!r || r.length < 3) continue;
      k = Number(r[0]);
      if (!m[k]) m[k] = {};
      m[k][r[1]] = String(r[2]);
    }
    return m;
  }

  function deltaFor(i, val) {
    var m = state && state.delta;
    return (m && m[i] && m[i][val]) || "";
  }

  function stockFor(handle) {
    if (!handle) return Promise.resolve(null);
    if (stock[handle] !== undefined) return Promise.resolve(stock[handle]);
    var pr = fetch("/products/" + encodeURIComponent(handle) + "?view=gt-stock",
                   { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (t) {
        var j = null;
        try { j = JSON.parse(String(t).trim()); } catch (e) { j = null; }
        stock[handle] = j;
        return j;
      })
      .catch(function () { stock[handle] = null; return null; });
    stock[handle] = pr;
    return pr;
  }

  function themeString(key, fallback) {
    try {
      var s = window.theme && window.theme.strings;
      if (s && typeof s[key] === "string" && s[key]) return s[key];
    } catch (e) {}
    return fallback;
  }

  /* The theme's own rule, from snippets/product-inventory.liquid. An untracked
     variant has no meaningful quantity, so it gets the plain label rather than
     a made up count. */
  function stockLine(v) {
    var plain = themeString("inStockLabel", "In stock, ready to ship");
    var data = state && state.stock;
    if (!v || !data || !data.v) return plain;
    var row = null, i;
    for (i = 0; i < data.v.length; i++) if (data.v[i].id === v.id) { row = data.v[i]; break; }
    if (!row || row.m !== "shopify" || row.p === "continue") return plain;
    var qty = Number(row.q), threshold = Number(data.th);
    if (!(qty > 0) || !(threshold >= 0) || qty > threshold) return plain;
    var t = qty === 1
      ? themeString("oneStockLabel", "Quick, only [count] left!")
      : themeString("otherStockLabel", "Low stock - Only [count] items left!");
    return t.replace("[count]", String(qty));
  }

  /* ---------------------------------------------------------------- */
  /* The cart.                                                         */

  function refresh() {
    try { if (typeof window.SLIDECART_UPDATE === "function") window.SLIDECART_UPDATE(); } catch (e) {}
  }

  function showCart() {
    refresh();
    try { if (typeof window.SLIDECART_OPEN === "function") window.SLIDECART_OPEN(); } catch (e) {}
  }

  /* A raw fetch to /cart/add.js is enough. Measured on 28 Sep against the
     SlideCart app's own upsell add: this path fires the same downstream work -
     Shopify's product_added_to_cart pixel, the Assortion discount call, the
     ads conversion and the progress bar - because they all listen to the cart
     rather than to the app's button. The app is told explicitly all the same,
     since it does not notice a raw fetch on its own. */
  function addToCart(id, qty) {
    return fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error("add");
      return r;
    });
  }

  /* ---------------------------------------------------------------- */
  /* The element.                                                      */

  function buildSheet() {
    if (sheet) return sheet;
    var el = document.createElement("div");
    el.className = "gt-sc-sheet gt-sc-sheet--shared";
    el.setAttribute("hidden", "hidden");
    el.innerHTML =
      '<div class="gt-sc-sheet__scrim" data-gt-close></div>' +
      '<div class="gt-sc-sheet__panel" role="dialog" aria-modal="true">' +
        '<button type="button" class="gt-sc-sheet__close" data-gt-close aria-label="Close">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 5l14 14M19 5L5 19" fill="none" stroke="currentColor" stroke-width="1.4"/></svg>' +
        '</button>' +
        '<div class="gt-sc-sheet__head">' +
          '<div class="gt-sc-sheet__thumb"><img class="gt-sc-sheet__img" alt="" /></div>' +
          '<div>' +
            '<div class="gt-sc-sheet__title"></div>' +
            '<span class="gt-sc-sheet__sum"></span>' +
          '</div>' +
        '</div>' +
        '<div class="gt-sc-sheet__opts"></div>' +
        '<p class="gt-sc-sheet__note" role="status" aria-live="polite"></p>' +
        '<button type="button" class="gt-sc-sheet__go">ADD TO CART</button>' +
      '</div>';
    /* APPENDED TO BODY, NOT TO THE CALLER. See the header: inside the slide
       cart's drawer a 140-declaration reset would flatten every control. */
    document.body.appendChild(el);
    el.addEventListener("click", function (e) {
      if (e.target && e.target.closest && e.target.closest("[data-gt-close]")) closeSheet();
    });
    q(".gt-sc-sheet__go", el).addEventListener("click", confirmSheet);
    sheet = el;
    return el;
  }

  /* Fix 4. Ask what is actually under the button and get out of its way. */
  function clearBottomChrome() {
    if (!sheet || !sheet.classList.contains("is-open")) return;
    var panel = q(".gt-sc-sheet__panel", sheet);
    var go = q(".gt-sc-sheet__go", sheet);
    if (!panel || !go) return;

    var base = 20, pad = 0, pass = 0;
    var cap = Math.round(window.innerHeight * 0.3);   /* never eat the sheet */
    panel.style.paddingBottom = "";

    /* MEASURE THE CHROME, NOT THE IFRAME IT LIVES IN. elementFromPoint returns
       IFRAME#PBarNextFrame, which spans the whole viewport, while the bar a
       shopper can see is the fixed DIV#PBarNextFrameWrapper at 744..812.
       Measuring the hit element's own rect asks for 840px of padding on an
       812px screen. The thing that occupies space is the positioned box. */
    function blocker(el) {
      for (var n = el; n && n !== document.body; n = n.parentElement) {
        var pos = getComputedStyle(n).position;
        if (pos === "fixed" || pos === "sticky") return n;
      }
      return el;
    }

    while (pass < 4) {
      var b = go.getBoundingClientRect();
      if (!b.width || !b.height) return;            /* not laid out yet */
      var hit = document.elementFromPoint(b.left + b.width / 2, b.top + b.height / 2);
      if (!hit) return;                             /* off screen */
      if (hit === go || go.contains(hit)) return;   /* reachable, done */
      var o = blocker(hit).getBoundingClientRect();
      var need = Math.max(0, window.innerHeight - o.top) + 8;
      if (!(need > pad)) need = pad + 24;           /* unmeasurable: step */
      pad = Math.min(need, cap);
      panel.style.paddingBottom = "calc(" + (base + pad) + "px + env(safe-area-inset-bottom, 0px))";
      if (pad >= cap) return;
      pass++;
    }
  }

  function closeSheet() {
    gen++;                       /* any open() still queued is now void */
    state = null;
    busy = false;
    if (!sheet) return;
    sheet.classList.remove("is-open");
    document.documentElement.classList.remove("gt-sheet-open");
    /* The hide is deferred so the panel can slide out, gated on the ticket
       rather than on re-reading a class a stale callback may have put back.
       The stylesheet stops the scrim catching anything in the meantime. */
    var mine = gen;
    setTimeout(function () {
      if (sheet && gen === mine) sheet.setAttribute("hidden", "hidden");
    }, 300);
  }

  function paintImage() {
    var img = q(".gt-sc-sheet__img", sheet);
    if (!img || !state) return;
    var p = state.product, v = state.variant;
    var src = (v && v.featured_image && v.featured_image.src) || p.featured_image || "";
    var want = sized(src, 400);
    if (img.getAttribute("src") !== want) img.setAttribute("src", want);
    img.setAttribute("alt", (v && v.name) || p.title || "");
    var thumb = q(".gt-sc-sheet__thumb", sheet);
    if (thumb) thumb.style.display = want ? "" : "none";
  }

  /* The shop's flat colour file, the variant's own photograph behind it, a
     colour keyword behind that.

     THE PHOTOGRAPH IS THE LAST RESORT, NOT THE SECOND ONE, decided by looking
     at it: of the Predator's six colours five resolve to a flat file and BLACK
     DOES NOT - /cdn/shop/files/black.png is a 404 on this shop - so it fell
     through to the variant's own image, a studio shot on a pale background
     that reads as light grey at 26px. A colour picker showing grey for Black
     is worse than useless. The photograph earns its place only where there is
     no keyword either, as on "Urban Rider". */
  function paintSwatch(el, val, photo) {
    /* The keyword first, because setting it is also how we find out whether it
       is real: the browser drops a value it does not understand, so reading the
       property back distinguishes "green" from "oxblood". */
    var word = handleize(String(val).split(" ").pop());
    if (word) el.style.backgroundColor = word;
    var named = el.style.backgroundColor !== "";
    var flat = "/cdn/shop/files/" + handleize(val) + "_60x60.png";
    var fallback = (!named && photo) ? sized(photo, 120) : "";
    function use(src) { if (src) el.style.backgroundImage = 'url("' + src + '")'; }
    if (swatchSrc[val] !== undefined) { use(swatchSrc[val] || fallback); return; }
    var probe = new Image();
    probe.onload = function () { swatchSrc[val] = flat; use(flat); };
    probe.onerror = function () { swatchSrc[val] = ""; use(fallback); };
    probe.src = flat;
  }

  function paintSheet() {
    if (!state) return;
    var p = state.product, vals = state.vals;

    qa(".gt-sc-val", sheet).forEach(function (el) {
      var i = Number(el.getAttribute("data-gt-i"));
      var val = el.getAttribute("data-gt-v");
      var gone;
      if (state.wide[i]) {
        /* A size rail answers about the product, not the current colour. */
        gone = !(state.index[i] && state.index[i].alive[val]);
      } else {
        var probe = vals.slice();
        probe[i] = val;
        var t = variantByValues(p, probe);
        gone = !(t && t.available);
      }
      el.classList.toggle("is-on", vals[i] === val);
      el.classList.toggle("is-gone", gone);
      el.setAttribute("aria-checked", vals[i] === val ? "true" : "false");
      /* The upcharge, on the chip, the way the PDP prints it. Written only
         when it changes, because this runs on every tap. A swatch is skipped:
         26px of colour has nowhere to put it - the summary line carries it. */
      var d = deltaFor(i, val);
      if (el.classList.contains("gt-sc-val--chip")) {
        var sm = el.querySelector("small");
        if (d) {
          if (!sm) { sm = document.createElement("small"); el.appendChild(sm); }
          if (sm.textContent !== d) sm.textContent = d;
        } else if (sm) {
          el.removeChild(sm);
        }
      }

      el.setAttribute("aria-label", val + (d ? " " + d : "") + (gone ? " - sold out" : ""));
    });

    var v = variantByValues(p, vals);
    state.variant = v;
    paintImage();

    var picked = vals.join(SEP);

    /* The summary is built rather than assigned, so a colour's upcharge can be
       brass beside its name. It is the only place in the sheet a colour is
       spelled out in words, which is why the swatch rails put it here. */
    var sum = q(".gt-sc-sheet__sum", sheet);
    sum.textContent = "";
    vals.forEach(function (val, i) {
      if (i) sum.appendChild(document.createTextNode(SEP));
      sum.appendChild(document.createTextNode(val));
      var d = state.swatch[i] ? deltaFor(i, val) : "";
      if (!d) return;
      var tag = document.createElement("small");
      tag.textContent = " " + d;
      sum.appendChild(tag);
    });

    var ok = !!(v && v.available);

    /* The status line is never empty, so nothing below it moves when the
       shopper taps around. A failure wins, then the two unbuyable cases, and
       otherwise the PDP's traffic light. No full stop on any of the three -
       see the header. */
    var note = q(".gt-sc-sheet__note", sheet);
    note.textContent = state.failed ? state.failed
      : (!v ? ("We do not make " + picked)
      : (!v.available ? (picked + " is currently sold out")
      : stockLine(v)));

    var go = q(".gt-sc-sheet__go", sheet);
    go.disabled = !ok || busy;
    go.textContent = busy ? state.busyLabel
      : (!v ? "UNAVAILABLE" : (!v.available ? "SOLD OUT" : state.confirmLabel));
  }

  function confirmSheet() {
    if (!state || busy) return;
    var v = state.variant;
    if (!v || !v.available) return;

    busy = true;
    state.failed = "";
    paintSheet();

    var settled = false;
    var mine = gen;

    /* Leave the sheet open so the choice is not lost, and say what happened.
       Silence here reads as a freeze: the button says ADDING..., nothing else
       moves, and the shopper has no idea whether to tap again. */
    function fail(msg) {
      if (settled) return;
      settled = true;
      clearTimeout(bail);
      busy = false;
      if (state && gen === mine) {
        state.failed = msg || "We could not add that just now. Nothing has been added to your cart.";
        paintSheet();
      }
      refresh();
    }

    function done() {
      if (settled) return;
      settled = true;
      clearTimeout(bail);
      busy = false;
      if (state && gen === mine) paintSheet();   /* clears the busy label while
                                                    state still exists */
      var after = state ? state.afterAdd : "open";
      closeSheet();
      if (after === "refresh") refresh(); else showCart();
    }

    /* A request that neither resolves nor rejects - a phone that lost its
       signal mid-post is the common one - would leave busy true and the button
       stuck forever, which is the freeze wearing a different hat. */
    var bail = setTimeout(function () {
      fail("That is taking longer than it should. Please check your cart before trying again.");
    }, CONFIRM_TIMEOUT);

    if (typeof state.onConfirm === "function") {
      try { state.onConfirm(v, done, fail); }
      catch (e) { fail(""); }
      return;
    }

    /* add.js enforces availability server side, so a variant that sold out
       while the sheet was open fails here rather than in the cart. */
    addToCart(v.id, 1).then(done).catch(function () { fail(""); });
  }

  /* ---------------------------------------------------------------- */

  /* THE PANEL TAKES THE CART'S COLUMN ON DESKTOP, NOT THE SCREEN'S WIDTH, and
     the width is measured rather than assumed: the app's drawer is 500px today
     and a merchant can change that in its settings. The stylesheet carries 500
     only as the fallback for when there is no drawer to measure. Below the
     breakpoint the custom property is ignored, so this costs one rect read and
     changes nothing on a phone. */
  function sizeToDrawer() {
    if (!sheet) return;
    var drawer = q("#slidecarthq .slidecarthq");
    if (!drawer) return;
    var w = drawer.getBoundingClientRect().width;
    if (w > 200) sheet.style.setProperty("--gt-sheet-w", Math.round(w) + "px");
  }

  function openSheet(opts) {
    opts = opts || {};
    var p = opts.product;
    if (!p || !p.variants || !p.variants.length) return false;

    buildSheet();

    var start = null, i;
    if (opts.startId) for (i = 0; i < p.variants.length; i++) if (p.variants[i].id === opts.startId) start = p.variants[i];
    if (!start) for (i = 0; i < p.variants.length; i++) if (p.variants[i].available) { start = p.variants[i]; break; }
    if (!start) start = p.variants[0];
    if (!start) return false;

    var names = optionNames(p);
    var token = p.handle + ":" + start.id + ":" + (gen + 1);

    state = {
      product: p,
      vals: start.options.slice(),
      variant: start,
      token: token,
      index: valueIndex(p),
      wide: names.map(function (n) { return SIZE.test(n); }),
      swatch: names.map(function (n) { return COLOUR.test(n); }),
      stock: null,
      delta: null,
      failed: opts.failed || "",
      confirmLabel: opts.confirmLabel || "ADD TO CART",
      busyLabel: opts.busyLabel || "ADDING...",
      afterAdd: opts.afterAdd === "refresh" ? "refresh" : "open",
      onConfirm: opts.onConfirm
    };
    busy = false;

    q(".gt-sc-sheet__title", sheet).textContent = p.title || "";

    var box = q(".gt-sc-sheet__opts", sheet);
    box.innerHTML = "";

    names.forEach(function (name, idx) {
      var row = state.index[idx];
      if (!row || row.order.length < 2) return;   /* one value is not a choice */
      var swatch = COLOUR.test(name);

      var el = document.createElement("div");
      el.className = "gt-sc-sheet__row";
      el.setAttribute("data-gt-row", String(idx));

      var lab = document.createElement("div");
      lab.className = "gt-sc-sheet__label";
      lab.textContent = name;

      var rail = document.createElement("div");
      rail.className = "gt-sc-sheet__vals gt-sc-sheet__vals--" + (swatch ? "swatch" : "chip");
      rail.setAttribute("role", "radiogroup");
      rail.setAttribute("aria-label", name);

      row.order.forEach(function (val) {
        var b = document.createElement("button");
        b.type = "button";
        b.className = "gt-sc-val " + (swatch ? "gt-sc-val--swatch" : "gt-sc-val--chip");
        b.setAttribute("role", "radio");
        b.setAttribute("data-gt-i", String(idx));
        b.setAttribute("data-gt-v", val);
        if (swatch) paintSwatch(b, val, row.photo[val]);
        else b.textContent = val;
        rail.appendChild(b);
      });

      el.appendChild(lab);
      el.appendChild(rail);
      box.appendChild(el);
    });

    /* One delegated handler rather than one per value, so five colours and
       eight sizes still cost a single listener. NOTHING IS DISABLED, so every
       tap lands - that is the point. */
    box.onclick = function (e) {
      var b = e.target && e.target.closest ? e.target.closest(".gt-sc-val") : null;
      if (!b || !state) return;
      e.preventDefault();
      state.failed = "";          /* a new choice clears the last failure */
      state.vals[Number(b.getAttribute("data-gt-i"))] = b.getAttribute("data-gt-v");
      paintSheet();
    };

    paintSheet();
    sheet.removeAttribute("hidden");

    /* Fixes 1 and 3. */
    gen++;
    var mine = gen;
    var open = function () {
      if (!sheet || gen !== mine) return;
      sizeToDrawer();
      sheet.classList.add("is-open");
      /* The scroll lock goes on WITH the sheet, not before it. Locked with
         nothing on screen is indistinguishable from a frozen page. */
      document.documentElement.classList.add("gt-sheet-open");
      /* Fix 4, three passes. */
      [320, 800, 1600].forEach(function (d) {
        setTimeout(function () { if (gen === mine) clearBottomChrome(); }, d);
      });
    };
    requestAnimationFrame(function () { requestAnimationFrame(open); });
    setTimeout(open, 60);

    /* The traffic light, fetched alongside. It only affects a line of type, so
       nothing waits on it, and a sheet that has moved on is ignored. */
    stockFor(p.handle).then(function (j) {
      if (!state || state.token !== token) return;
      state.stock = j;
      state.delta = deltaMap(j);
      paintSheet();
    });

    return true;
  }

  /* The belt to the generation guard's braces. If the sheet is on screen with
     no state behind it, the page is dead under a transparent layer and nothing
     else will notice - a frozen page produces no mutations, so no observer
     fires. One class check on a tap, and a broken page heals itself. */
  function healSheet() {
    if (sheet && !state && sheet.classList.contains("is-open")) closeSheet();
  }

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && sheet && sheet.classList.contains("is-open")) closeSheet();
  });

  /* A tap is the signal that matters. Passive and capture, so this never
     interferes with the tap itself; worst case the shopper loses one tap
     instead of the page. */
  ["touchstart", "pointerdown"].forEach(function (ev) {
    document.addEventListener(ev, healSheet, { passive: true, capture: true });
  });

  /* A rotated phone has different chrome in the bottom band, and an iOS
     toolbar that hides changes the viewport without firing resize on some
     builds - so orientationchange is listened for as well. A desktop window
     drag lands here too, which is where sizeToDrawer earns its place. */
  var rt = null;
  function reclear() {
    clearTimeout(rt);
    rt = setTimeout(function () { sizeToDrawer(); clearBottomChrome(); }, 200);
  }
  window.addEventListener("resize", reclear);
  window.addEventListener("orientationchange", reclear);

  window.GTSheet = {
    open: openSheet,
    close: closeSheet,
    isOpen: function () { return !!(sheet && sheet.classList.contains("is-open") && state); },
    addToCart: addToCart,
    showCart: showCart,
    refresh: refresh
  };
})();
